import React from 'react';

function getHeaderOffset() {
  // Bottom edge of the fixed site header (marketing banner + nav). Falls
  // back to the legacy 90px when the header is collapsed or absent.
  const headerBottom =
    document.querySelector('header')?.getBoundingClientRect().bottom ?? 0;
  return Math.max(90, headerBottom + 12);
}

function getBottomBarHeight() {
  return (
    document.querySelector('[data-bottom-bar]')?.getBoundingClientRect()
      .height ?? 0
  );
}

export function flashTitle(elementRef: React.RefObject<HTMLDivElement | null>) {
  if (!elementRef.current) return;
  const target = elementRef.current.querySelector<HTMLElement>(
    '.section-row-title h5',
  );
  if (!target) return;
  target.style.transition = 'transform 0.5s ease';
  target.style.transform = 'scale(1.1)';
  setTimeout(() => {
    target.style.fontSize = '';
    target.style.transform = '';
  }, 500);
}

export function isVisible(elementRef: React.RefObject<HTMLDivElement | null>) {
  const rect = elementRef.current?.getBoundingClientRect();
  return (
    rect &&
    rect.top >= getHeaderOffset() &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) -
        getBottomBarHeight() &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function scrollToElement(
  elementRef: React.RefObject<HTMLDivElement | null>,
) {
  if (!elementRef.current) return;
  // Anchor the section's title row (the section itself carries top padding)
  // so the title lands just below the fixed header.
  const anchor =
    elementRef.current.querySelector('.section-row-title') ??
    elementRef.current;
  const rect = anchor.getBoundingClientRect();
  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;
  window.scrollTo({
    top: window.scrollY + rect.top - getHeaderOffset(),
    behavior: reduceMotion ? 'auto' : 'smooth',
  });
}

export function highlightElement(
  elementRef: React.RefObject<HTMLDivElement | null>,
) {
  if (!elementRef.current) return;

  if (!isVisible(elementRef)) scrollToElement(elementRef);
  flashTitle(elementRef);
}
